import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  autoTag: {
    description: 'Barcode field auto-generated tag label',
    defaultMessage: 'Auto',
    id: 'VMJdQW',
  },
  regenerateAriaLabel: {
    description: 'Barcode field regenerate icon button aria label',
    defaultMessage: 'Regenerate barcode',
    id: 'QSZkm9',
  },
  editAriaLabel: {
    description: 'Barcode field edit icon button aria label',
    defaultMessage: 'Edit barcode manually',
    id: 'Fr+AKy',
  },
  useAutoButton: {
    description: 'Barcode field use-auto button label',
    defaultMessage: 'Use auto',
    id: '6OLn83',
  },
  required: {
    description: 'Barcode field required validation error',
    defaultMessage: 'Barcode is required',
    id: 'C+Xd71',
  },
  invalidChars: {
    description: 'Barcode field invalid characters validation error',
    defaultMessage: 'Only letters, digits, and - . _ are allowed',
    id: '1bcTqS',
  },
  maxLength: {
    description: 'Barcode field max length reached message',
    defaultMessage: 'Max 100 characters',
    id: '4di1F3',
  },
  duplicate: {
    description: 'Barcode field warning when the entered barcode already exists on another UoM unit',
    defaultMessage: 'Barcode already exists for this product.',
    id: 'v15hGF',
  },
});
